// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1, // Store Custom Code
        alternateBorderWidth: 2, // Store Custom Code
    },
    // Store Custom Code
    productConfigurationSection: {
        embroidery: "embroidery",
    },
    accountCreationFormFields: {
        email: {
            label: "Email",
            placeholder: "e.g. name@example.com",
            required: true,
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            regexErrorMessage: "Invalid email format. Use name@example.com",
        },
        businessOrIndividual: { label: "Registered Business / Individual", placeholder: "", required: true },
        legalName: {
            label: "Legal Name",
            placeholder: "Legal Name",
            required: true,
            requiredParentFieldKey: "businessOrIndividual",
            requiredParentFieldValue: "business",
        },
        doingBusinessAs: {
            label: "Doing Business As",
            placeholder: "Business Name",
            required: true,
            requiredParentFieldKey: "businessOrIndividual",
            requiredParentFieldValue: "business",
        },
        individualName: {
            label: "Individual Name",
            placeholder: "Your Name",
            required: true,
        },
        phone: {
            label: "Phone",
            placeholder: "Phone",
            required: true,
            regex: /^(\+?\d{1,3}[\s\-]?)?(\(?\d{3}\)?[\s\-]?)?\d{3}[\s\-]?\d{4}$/,
            regexErrorMessage: "Invalid phone format. Examples: (123) 456-7890, 123-456-7890, +1 123 456 7890",
        },
        additionalInformation: {
            label: "Additional Information",
            placeholder: "Additional Info",
            required: false,
        },
    },
});
